(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }
    // get product data
    let product =  JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".productVariantJSON").textContent);
    let quantity = 1;

    // gift card properties
    let properties = {};

    // checks if engraving dialog is open
    function engravingIsOpen() {
        return !!section.querySelector(".engrave")?.open;
    }

    /************
     Product Swipers
     ************/
    document.querySelectorAll('.productVisualSwiper').forEach(swiper => {

        // thumbs
        let target = swiper.dataset.thumbsTarget;
        let thumbsElement = document.querySelector(`[id='${target}']`);

        let thumbsSwiper = new Swiper(document.querySelector(`[id='${target}']`), {
            slidesPerView: 3.5,
            spaceBetween: 15,
            direction: "vertical"
        });

        // swiper
        let productSwiper = new Swiper(document.querySelector(`[id='${swiper.id}']`), {
            slidesPerView: 1,
            spaceBetween: 20,
            autoHeight: true,
            loop: true,
            thumbs: {
                swiper: thumbsSwiper
            },
            navigation: {
                nextEl: thumbsElement.querySelector(".productVisualThumbsNext"),
                prevEl: thumbsElement.querySelector(".productVisualThumbsPrev"),
            },
            pagination: {
                el: swiper.querySelector(".productVisualSwiperPag"),
                clickable: true
            },
            on: {
                slideChange: function () {
                    // update the thumbnail active class
                    thumbsElement.querySelector(".productVisualThumbsSlideImg.active")?.classList.remove("active");
                    thumbsElement.querySelectorAll(".productVisualThumbsSlideImg")[this.realIndex]?.classList.add("active");

                    // mobile prev/next buttons
                    if (window.innerWidth < 800) {
                        swiper.querySelector(".productVisualSwiperNext").classList.add("active");
                        swiper.querySelector(".productVisualSwiperPrev").classList.add("active");

                        // if we're on the first slide, hide the prev button
                        if (this.realIndex === 0) {
                            swiper.querySelector(".productVisualSwiperPrev").classList.remove("active");
                        }
                        // if we're on the last slide, hide the next button
                        if (this.realIndex === this.slides.length - 1) {
                            swiper.querySelector(".productVisualSwiperNext").classList.remove("active");
                        }
                    }
                }
            }
        });

        // show prev/next on mobile
        if (window.innerWidth < 800) {
            swiper.querySelector(".productVisualSwiperNext").classList.add("active");
        }

        // mobile prev/next
        swiper.querySelector(".productVisualSwiperNext").addEventListener("click", function () {
            productSwiper.slideNext();
        });
        swiper.querySelector(".productVisualSwiperPrev").addEventListener("click", function () {
            productSwiper.slidePrev();
        });

    });

    //

    // disable magic zoom on desktop
    if (window.innerWidth > 800) {
        section.querySelectorAll('.productVisualSwiperSlide').forEach(slide => {
            slide.classList.remove('MagicZoom')
            slide.addEventListener('click', function (e) {
                e.preventDefault();
            });
        })
    }

    // play video on slide play click
    section.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productVisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productVisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    // update active variant on input changes
    section.querySelectorAll(".product input").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct();
        });
    })

    // update active variant on select changes
    section.querySelectorAll(".product select").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct();
        });
    })

    // remove white space lines from upsell descriptions
    section.querySelectorAll('.upsellBodyInfo')?.forEach(element => {
        let text = element.textContent;

        // remove all &nbsp;
        text = text.replace(/\u00A0/g, ' ');
        text = text.replace(/&nbsp;/g, ' ');
        element.textContent = text;
    })

    if (window.innerWidth > 800) {
        section.querySelector('.productTitleReviews')?.addEventListener('click', function () {
            let reviewsSection = document.querySelector('.reviews') || false;
            if (reviewsSection) {
                // Calculate the scroll position, considering the sticky header height
                let reviewsOffsetTop = reviewsSection.offsetTop - 150;

                // Scroll to the calculated position
                window.scrollTo({
                    top: reviewsOffsetTop,
                    behavior: 'smooth'
                });
            }
        });
    }

    /**************
     Update Product
     ***************/
    async function updateProduct() {

        // variables to check if elements exist
        let productATCExists = section.querySelector(".productATC") || false;
        let priceExists = section.querySelector(".productPrice") || false;
        let sellingPlanExists = section.querySelector(".productSelling") || false;
        let payInstallmentsExits = section.querySelector("shopify-payment-terms") || false;
        let locationsExists = section.querySelector(".productPickup") || false;
        let optionsWrapper = section.querySelector('.productOption'); // Wraps the variant options. There can be multiple due to the engraving dialog

        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {

            // if engraving dialog is open, use the engraving input as the target element wrapper to find the variant
            if (engravingIsOpen()) {
                optionsWrapper = section.querySelector('.engraveBodyOption');
            }

            // collect all option values by their names, then map to correct order
            let optionsByName = {};

            // collect options from inputs (colors)
            optionsWrapper.querySelectorAll(`.productOptionItem.colors`)?.forEach(group => {
                let name = group.dataset.name;
                optionsByName[name] = group.querySelector(`input:checked`)?.value;
            });

            // collect options from radio buttons
            optionsWrapper.querySelectorAll(`.productOptionItem.radios`)?.forEach(group => {
                let name = group.dataset.name;
                optionsByName[name] = group.querySelector(`input:checked`)?.value;
            });

            // collect options from selects
            optionsWrapper.querySelectorAll(`.productOptionItemSelect`)?.forEach(select => {
                let name = select.dataset.name;
                optionsByName[name] = select?.value;

            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                // normalize option values for comparison
                let variantOptionNames = product.options || [];
                let userOptions = variantOptionNames.map(name => optionsByName[name]?.trim());
                let variantOptions = (variant.options || []).map(opt => opt.trim());

                return JSON.stringify(userOptions) === JSON.stringify(variantOptions);
            });
        }


        // check if variant wasn't found
        if ((activeVariant === null || activeVariant === undefined)) {
            if (productATCExists) {
                // Disable ATC button
                section.querySelectorAll(".productATC").forEach(button => {
                    button.classList.add("oos");
                    button.textContent = "Sold Out — Notify Me When Available";
                });
            }
            return;
        }

        afterpayTrigger()

        // update the selected option text
        optionsWrapper?.querySelectorAll('.productOptionItem.colors')?.forEach(function (element) {
            let premiumExists = element.querySelector('.productOptionItemLabelChoice.premium') || false;

            // show the selected option in the correct place
            if (optionsWrapper.querySelector('input:checked')?.classList.contains('premium')) {
                if (premiumExists) {
                    optionsWrapper.querySelector('.productOptionItemLabelChoice.premium').textContent = ` | ` + element.querySelector('input:checked').value;
                }
                optionsWrapper.querySelector('.productOptionItemLabelChoice.regular').textContent = '';
            } else {
                optionsWrapper.querySelector('.productOptionItemLabelChoice.regular').textContent = ` | ` + element.querySelector('input:checked').value;
                if (premiumExists) {
                    optionsWrapper.querySelector('.productOptionItemLabelChoice.premium').textContent = '';
                }
            }
        });

        /**************
         Variant Image
         ***************/
        // don't update while engraving open
        if (engravingIsOpen()) {
            // get variant image
            let variantImage = variantIDtoEngravingImg[activeVariant.id] || false;

            // update the image in the engraving dialog
            if (variantImage) {
                section.querySelector('.engraveBodyZoomImg').src = variantImage;
            } else {
                section.querySelector('.engraveBodyZoomImg').src = activeVariant.image?.src || '';
            }

        } else {
            section.querySelectorAll('.productVisualWrap').forEach(element => {
                // change active swiper
                element.classList.remove("active");
                if (activeVariant.id === parseInt(element.dataset.variantId)) {
                    element.classList.add("active");
                }
            });
        }


        /**************
         Price
         ***************/
        if (priceExists) {
            section.querySelector(".productPriceReal").textContent = price(activeVariant.price * quantity);
            section.querySelector(".productPriceReal").setAttribute("data-variant-id", activeVariant.id);
            if (activeVariant.compare_at_price > activeVariant.price) {
                section.querySelector(".productPriceReal").classList.add("sale");
                section.querySelector(".productPriceCompare").textContent = price(activeVariant.compare_at_price * quantity);
                section.querySelector(".productPriceCompare").setAttribute("data-variant-id", activeVariant.id);
            } else {
                section.querySelector(".productPriceReal").classList.remove("sale");
                section.querySelector(".productPriceCompare").textContent = "";
                section.querySelector(".productPriceCompare").setAttribute("data-variant-id", activeVariant.id);
            }
        }

        // update save price
        section.querySelectorAll('.productVisualSave').forEach(element => {
            element.classList.remove('active');
        })

        if (activeVariant.compare_at_price > activeVariant.price) {
            let save = (1 - (activeVariant.price / activeVariant.compare_at_price)) * 100;
            section.querySelectorAll('.productVisualSave').forEach(element => {
                element.classList.add('active');
                element.textContent = `${save.toFixed(0)}% OFF`;
            })
        }

        // update engraving price
        let engravingExists = section.querySelector('.productEngrave') || false;
        if (engravingExists) {
            section.querySelector(".engraveBodyATCReceiptItemPrice.real").textContent = price(activeVariant.price);
            section.querySelector(".engraveBodyATCReceiptItemPrice.total").textContent = price(activeVariant.price + 995); // add $9.95 engraving fee

        }


        /**************
         Selling Plan
         ***************/
        if (sellingPlanExists) {
            let activeVariantPlan = activeVariant.selling_plan_allocations[0];

            // find the correct selling_plan_allocation
            for (let plan of activeVariant.selling_plan_allocations) {
                if (plan.selling_plan_id === parseInt(document.querySelector('.productSellingLabelBodyBottomWrapContentLabelInput:checked').value)) {
                    activeVariantPlan = plan;
                }
            }

            // update savings text
            let save = (1 - (activeVariantPlan.price / activeVariant.price)) * 100;
            section.querySelector('.productSellingLabelBodyTopTitle').textContent = `Subscribe & Save ` + save.toFixed(0) + `%`;

            // save parent elements
            const once = section.querySelector(".productSellingLabelBody.once");
            const sub = section.querySelector(".productSellingLabelBody.sub");

            // update compare at price
            once.querySelector(".productSellingLabelBodyPriceCompare").textContent = "";
            sub.querySelector(".productSellingLabelBodyPriceCompare").textContent = price(activeVariantPlan.compare_at_price * quantity, true);
            if (activeVariant.compare_at_price > activeVariant.price) {
                once.querySelector(".productSellingLabelBodyPriceCompare").textContent = price(activeVariant.compare_at_price * quantity, true);
            }

            // update actual price
            once.querySelector(".productSellingLabelBodyPriceReal").textContent = price(activeVariant.price * quantity, true);
            sub.querySelector(".productSellingLabelBodyPriceReal").textContent = price(activeVariantPlan.price * quantity, true);


            // update price outside of selling plan module if selling plan is selected
            if (priceExists && section.querySelector(".productSellingLabelInput:checked")?.value === "sub") {
                section.querySelector(".productPriceReal").textContent = price(activeVariantPlan.price * quantity);
                section.querySelector(".productPriceCompare").textContent = price(activeVariantPlan.compare_at_price * quantity);
            }
        }

        /**************
         Pay Installments
         ***************/
        if (payInstallmentsExits) {
            // update payments form data
            section.querySelector('.productPaymentsInput').value = activeVariant.id;
            section.querySelector('shopify-payment-terms').dataset.variantId = activeVariant.id;
            section.querySelector('shopify-payment-terms').setAttribute('variant-id', activeVariant.id);
        }


        /**************
         ATC Enable/Disable
         ***************/
        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelectorAll(".productATC").forEach(button => {
                button.textContent = "Add To Cart";
                button.classList.remove("oos");
                if (button.classList.contains("checkout")) {
                    button.textContent = "Checkout";
                }
            });
        } else {
            section.querySelectorAll(".productATC").forEach(button => {
                button.textContent = "Sold Out — Notify Me When Available";
                button.classList.add("oos");
            });
        }
        

        /**************
         Pickup Locations
         ***************/
        if (locationsExists) {
            // update pickup location
            await updateLocation(activeVariant.id, '.productPickup');

            // update dialog pickup locations
            await updateLocation(activeVariant.id, '.pickupContentBody');
        }

        // update properties (gift card)
        section.querySelectorAll(".productGiftCardInput")?.forEach(function (element) {
            properties[element.name] = element.value;
        });

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();

    /**************
     Product Quantity
     ***************/

    // minus
    section.querySelector(".productQuantityControlsBtn.minus")?.addEventListener("click", function () {
        if (quantity === 1) {
            return;
        }
        quantity--;
        section.querySelector(".productQuantityControlsValue").textContent = quantity;
        updateProduct();
    });

    // plus
    section.querySelector(".productQuantityControlsBtn.plus")?.addEventListener("click", function () {
        quantity++;
        section.querySelector(".productQuantityControlsValue").textContent = quantity;
        updateProduct();
    });


    /**************
     Product ATC
     ***************/
    section.querySelectorAll('.productATC')?.forEach(button => {
        button.addEventListener("click", async function () {

            // check for out of stock
            if (this.classList.contains("oos")) {
                // check email
                let {value: email} = await Swal.fire({
                    title: product.title,
                    text: "Enter your email to be notified when this product is back in stock.",
                    input: "email",
                    inputPlaceholder: "Email Address",
                    confirmButtonText: "Notify Me When Available",
                });

                // confirm email is returned
                if (!email) {
                    return;
                }

                // add to waitlist
                let formData = new FormData();
                formData.append("a", await klaviyo.account());
                formData.append("email", email);
                formData.append("g", "");
                formData.append("variant", activeVariant.id);
                formData.append("product", product.id);
                formData.append("platform", "shopify");
                formData.append("subscribe_for_newsletter", false);
                fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
                    method: "POST",
                    body: formData
                })

                // show success message
                await Swal.fire({
                    title: "Success!",
                    text: "You will be notified when this product is back in stock.",
                    confirmButtonText: "OK",
                });

                return;
            }

            // check for engraving
            if (this.classList.contains("engraving")) {
                let engravingText = section.querySelector(".engraveBodyInput").value.toUpperCase();

                // check if engraving is empty
                if (engravingText.trim().length === 0) {
                    await Swal.fire({
                        target: section.querySelector('.engrave'),
                        title: "Engraving Required",
                        text: "Can't leave text empty",
                        icon: "error",
                        confirmButtonText: "OK"
                    });
                    this.classList.remove("loading");
                    return;
                }

                // add engraving to properties
                properties['Engraving'] = engravingText;

            } else {
                // remove engraving property if it exists
                delete properties['Engraving'];
            }

            // add loading animation
            this.classList.add("loading");


            let formData = {
                items: [{
                    quantity: quantity,
                    id: activeVariant.id,
                    properties: properties || null
                }]
            };


            // check for selling plan
            if (section.querySelector('.productSellingLabelInput.sub')?.checked) {
                // find the correct selling_plan_allocation
                let activeVariantPlan = activeVariant.selling_plan_allocations[0];
                // find the correct selling_plan_allocation
                for (let plan of activeVariant.selling_plan_allocations) {
                    if (plan.selling_plan_id === parseInt(section.querySelector('.productSellingLabelBodyBottomWrapContentLabelInput:checked').value)) {
                        activeVariantPlan = plan;
                    }
                }
                formData.items[0].selling_plan = activeVariantPlan.selling_plan_id
            }

            // check for upsell
            document.querySelectorAll('.productUpsellItemContainerContentLabelInput')?.forEach(element => {
                if (element.checked) {
                    formData.items.push({
                        quantity: 1,
                        id: parseInt(element.value)
                    });

                    // track
                    window.igEvents = window.igEvents || [];
                    window.igEvents.push({
                        "event": "added_to_cart_pdp"
                    })

                }
            })

            // add product
            await addProduct(formData);

            // remove loading animation
            this.classList.remove("loading");

            // checkout
            if (this.classList.contains("checkout")) {
                window.location.href = `${Shopify.routes.root}checkout`;
                return;
            }

            // check for engraving and close popup
            if (this.classList.contains("engraving")) {
                closePopup();
            }

            // open cart
            await openCart();
        });
    });

    /**************
     Pickup Locations Rendering
     ***************/

    // inserts pickup location HTML into section
    // Takes variantID and the target class to insert the pickup locations
    async function updateLocation(variantID, targetClass) {
        // section rendering API - fetch pickup locations
        fetch(window.Shopify.routes.root + `variants/${variantID}/?section_id=${section.id}`)
            .then(response => response.text())
            .then(text => {
                // create temp div to parse html
                let html = document.createElement('div');
                html.innerHTML = text;
                let locations = html.querySelector(`${targetClass}`);

                // insert locations
                if (locations && locations.innerHTML.trim().length) {
                    section.querySelector(`${targetClass}`).innerHTML = locations.innerHTML;

                    // attach event listeners
                    // open pickup event listener
                    section.querySelectorAll(".openPickup")?.forEach(function (element) {
                        element.addEventListener("click", openPickup);
                    });
                }
            })
            .catch(e => {
                console.error(e);
            });
    }

    /**************
     Dropdowns
     ***************/
    section.querySelectorAll(".productDropdownTop").forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });

    /**************
     Upsell Dropdowns
     ***************/
    section.querySelectorAll(".productUpsellControlBtn")?.forEach(element => {
        element.addEventListener("click", function () {
            // toggle active class
            this.classList.toggle("active");

            section.querySelector('.productUpsellControlBtnTxt').textContent = "All add-ons";
            if (this.classList.contains("active")) {
                section.querySelector('.productUpsellControlBtnTxt').textContent = "Hide";
            }

            // toggle the dropdown
            section.querySelector(".productUpsell").querySelector(".productUpsellDropdown").classList.toggle("active");
        });
    });

    // upsell item dropdown
    section.querySelectorAll('.productUpsellItemContainerContentInfo')?.forEach(element => {
        element.addEventListener('click', function () {
            // open info dialog
            element.querySelector('.productUpsellItemContainerContentInfoTooltip').click();


        })
    })

    // listen for input switch, if the input is checked make sure the dropdown is open
    section.querySelectorAll('.productUpsellItemContainerContentLabelInput')?.forEach(element => {
        element.addEventListener('change', function () {
            // check if dropdown exists
            let dropDownExists = element.closest('.productUpsellItem').querySelector('.productUpsellItemBodyDrop') || false;

            if (!dropDownExists) {
                return;
            }

            // toggle the dropdown
            element.closest('.productUpsellItem').querySelector('.productUpsellItemBodyDrop').classList.toggle('active');

        })
    })


    /**************
     Upsell Logic
     ***************/
    section.querySelectorAll('.productUpsellItem')?.forEach(upsell => {
        // when an upsell select input is changed
        upsell.querySelector('.productUpsellItemBodyDropWrapContentSelect')?.addEventListener('change', function () {

            let selectedOption = this.querySelector('option:checked');
            let variant = JSON.parse(selectedOption.value);

            // update the image
            upsell.querySelector('.productUpsellItemBodyDropWrapContentImg').src = selectedOption.dataset.image;
            upsell.querySelector('.productUpsellItemContainerContentInfoUpperImg').src = selectedOption.dataset.image;


            // update the value of the main input (we use this for the ATC)
            upsell.querySelector('.productUpsellItemContainerContentLabelInput').value = variant.id;

            // update the price
            upsell.querySelector('.productUpsellItemContainerPriceReal').textContent = price(variant.price);
            upsell.querySelector('.productUpsellItemContainerPriceReal').setAttribute('data-variant-id', variant.id);
            upsell.querySelector('.productUpsellItemContainerPriceCompare').textContent = "";
            upsell.querySelector('.productUpsellItemContainerPriceCompare').setAttribute('data-variant-id', variant.id);
            if (variant.compare_at_price > variant.price) {
                upsell.querySelector('.productUpsellItemContainerPriceCompare').textContent = price(variant.compare_at_price);
            }
        });
    })


    /**************
     Upsell Switch Product
     ***************/
    // Some products have links between them and a similar product
    // ie. The classic wallet and the Magsafe.
    // In the upsells, allow the user to toggle between the two products
    section.querySelectorAll('.productUpsellItemBodyDropWrapContentLinkedLabelInput')?.forEach(input => {
        input.addEventListener('change', function () {
            let linkedProduct = JSON.parse(this.value);

            if (!linkedProduct) return;

            // update the upsell info
            let upsellContainer = input.closest('.productUpsellItem');

            // update price
            upsellContainer.querySelector('.productUpsellItemContainerPriceReal').textContent = price(linkedProduct.price, true);
            upsellContainer.querySelector('.productUpsellItemContainerPriceCompare').textContent = '';
            if (linkedProduct.compare_at_price > linkedProduct.price) {
                upsellContainer.querySelector('.productUpsellItemContainerPriceCompare').textContent = price(linkedProduct.compare_at_price, true);
            }

            // update image
            upsellContainer.querySelector('.productUpsellItemBodyDropWrapContentImg').src = linkedProduct.featured_image + '&width=200';
            upsellContainer.querySelector('.productUpsellItemContainerContentInfoUpperImg').src = linkedProduct.featured_image + '&width=200';

            // update options
            let originalSelectedOption = JSON.parse(upsellContainer.querySelector('.productUpsellItemBodyDropWrapContentSelect option:checked')?.value);

            upsellContainer.querySelector('.productUpsellItemBodyDropWrapContentSelect').innerHTML = '';
            linkedProduct.variants.forEach((variant) => {
                let option = document.createElement('option');
                option.value = JSON.stringify(variant);
                let soldOut = ''
                if (!variant.available) {
                    soldOut = ' (SOLD OUT)';
                    option.disabled = true;
                }
                option.textContent = variant.title + soldOut;
                option.dataset.image = variant.featured_image.src + '&width=200';
                upsellContainer.querySelector('.productUpsellItemBodyDropWrapContentSelect').appendChild(option);
            })

            // try to reselect the original option if it exists
            upsellContainer.querySelectorAll('option').forEach(option => {
                let variant = JSON.parse(option.value);
                if (variant.title === originalSelectedOption.title) {
                    option.selected = true;

                    // trigger change event to update the rest of the upsell
                    upsellContainer.querySelector('.productUpsellItemBodyDropWrapContentSelect').dispatchEvent(new Event('change'));
                }
            })

            // update info popup
            let infoPopupID = upsellContainer.querySelector('.productUpsellItemContainerContentInfoTooltip').dataset.target;
            let infoPopup = document.querySelector(`#${infoPopupID}`);
            infoPopup.querySelector('.upsellBodyTitle').textContent = linkedProduct.title;
            infoPopup.querySelector('.upsellBodyInfo').innerHTML = linkedProduct.description;

            // update the first image
            infoPopup.querySelector('.upsellBodySwiperSlideImg').src = linkedProduct.featured_image + '&width=400';


        })
    })


    /**************
     Pickup Dialog
     ***************/
    // open pickup
    function openPickup() {
        section.querySelector(".pickup")?.showModal();
        document.querySelector("body").classList.add("noScroll");
    }

    // dialog close event
    section.querySelector(".pickup")?.addEventListener("close", async function () {
        document.querySelector("body").classList.remove("noScroll");
    });

    // close pickup
    function closePickup() {
        section.querySelector(".pickup")?.close();
    }

    // open pickup event listener
    section.querySelectorAll(".openPickup")?.forEach(function (element) {
        element.addEventListener("click", openPickup);
    });

    // close pickup event listener
    section.querySelectorAll(".closePickup")?.forEach(function (element) {
        element.addEventListener("click", closePickup);
    });

    section.querySelector(".pickup")?.addEventListener("click", function (e) {
        if (e.target === this) {
            closePickup();
        }
    })

    // register dialog
    if (section.querySelector(".pickup")) {
        dialogPolyfill.registerDialog(section.querySelector(".pickup"));
    }

    /**************
     Engraving Dialog
     ***************/

    // open engrave dialog
    section.querySelectorAll('.productEngrave')?.forEach(function (element) {
        element.addEventListener('click', function () {
            section.querySelector(".engrave").showModal();
            document.querySelector("body").classList.add("noScroll");
            updateProduct();
        });
    })

    // close engrave
    function closePopup() {
        section.querySelector(".engrave").close();
        document.querySelector("body").classList.remove("noScroll");
        updateProduct();
    }

    // close engrave event listener
    section.querySelectorAll(".closeEngraving")?.forEach(function (element) {
        element.addEventListener("click", closePopup);
    });

    section.querySelector(".engrave")?.addEventListener("click", function (e) {
        if (e.target === this) {
            closePopup();
        }
    })

    // close event
    section.querySelector(".engrave")?.addEventListener("close", function () {
        document.querySelector("body").classList.remove("noScroll");
    });

    // register dialog
    if (section.querySelector(".engrave")) {
        dialogPolyfill.registerDialog(section.querySelector(".engrave"));
    }

    // check query params for engraving=true, if so open engraving
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('engraving') === 'true') {
        section.querySelector(".engrave").showModal();
        document.querySelector("body").classList.add("noScroll");
    }

    // listen for engraving input change
    section.querySelectorAll(".engraveBodyInput")?.forEach(function (element) {
        element.addEventListener('input', function () {

            // strip any emojis
            let value = this.value.replace(/[^a-zA-Z0-9 ]/g, '');

            // limit to 14 char
            if (value.length > 14) {
                value = value.substring(0, 14);
            }

            element.value = value;
            section.querySelector('.engraveBodyZoomTxt').textContent = value;

        })
    })


    document.addEventListener("DOMContentLoaded", () => {
        afterpayTrigger()
    });


    function afterpayTrigger() {

        // Afterpay overrides - hide popup button
        function overrideAfterpay() {
            const placement = section.querySelector('square-placement');
            if (placement && placement.shadowRoot) {
                const logoLink = placement.shadowRoot.querySelector('#logo-link');
                const logo = placement.shadowRoot.querySelector('.afterpay-logo');
                if (logoLink && logo) {
                    logoLink.style.setProperty('display', 'none', 'important');
                    logo.style.setProperty('pointer-events', 'none', 'important');
                    return true;
                }
            }
            return false;
        }

        // Try to override Afterpay buttons
        let maxAttempts = 30;
        const interval = setInterval(() => {
            if (overrideAfterpay() || maxAttempts <= 0) {
                clearInterval(interval);
            }
            maxAttempts--;
        }, 100);

    }

}());
/**************
 Product Bottom
 ***************/
if (window.innerWidth < 800) {
    // show on scroll
    let isVisible = false;
    const productBottomATC = document.querySelector('#productBottom');
    const sectionATC = document.querySelector(".productATC");

    // listen if the original ATC button is scrolled off screen
    window.addEventListener('scroll', function () {
        const scrollTop = window.scrollY;
        const buttonOffsetTop = sectionATC.offsetTop;

        if (scrollTop > buttonOffsetTop && !isVisible) {
            productBottomATC.classList.add('active');
            isVisible = true;
        } else if (scrollTop <= buttonOffsetTop && isVisible) {
            productBottomATC.classList.remove('active');
            isVisible = false;
        }
    })
}

